import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/archive";
import SubscribeForm from "@/components/feature/SubscribeForm";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/timeline", label: "暗黑时间轴" },
  { to: "/archive", label: "档案库" },
  { to: "/about", label: "关于我们" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-foreground-700">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-950">
                <i className="ri-node-tree text-2xl" aria-hidden="true"></i>
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-foreground-900">
                  {siteInfo.name}
                </span>
                <span className="mt-1 text-[10px] tracking-[0.28em] uppercase text-foreground-500">
                  Dark Line Archive
                </span>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-foreground-500">
              {siteInfo.tagline}。用清晰的时间顺序串联碎片化信息，让事件脉络可读、可查、可核对。
            </p>
            <p className="mt-5 text-sm text-foreground-500">
              <i className="ri-mail-line mr-2" aria-hidden="true"></i>
              {siteInfo.email}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900">
              <Link to="/" className="cursor-pointer">网站导航</Link>
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900">
              <Link to="/archive" className="cursor-pointer">主题分类</Link>
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/archive?cat=${cat.id}`}
                    className="cursor-pointer text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div id="subscribe" className="scroll-mt-24">
            <h4 className="font-heading text-base font-semibold text-foreground-900">
              订阅更新汇总
            </h4>
            <p className="mt-4 text-sm text-foreground-500">
              每期专题整理完成后，发送一次新增档案与勘误汇总。
            </p>
            <div className="mt-5">
              <SubscribeForm />
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-foreground-900/20 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-foreground-600">
          <p>© {siteInfo.est}–2026 {siteInfo.name} · 内容以公开记录与调查报告为基础整理</p>
          <p className="flex items-center gap-2">
            <i className="ri-information-line" aria-hidden="true"></i>
            涉及争议结论时，请以原始资料为准
          </p>
        </div>
      </div>
    </footer>
  );
}